'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
let app = window.app;
class JobAdsFrontListDetails extends _react.Component {
  state = {
    loading: false,
    jobad_id: document.location.pathname.split('/annonces/')[1],
    current_info: 0,
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const candidate_id = app.state?.session?.user?.id;
    component.setState({
      candidate_id: candidate_id
    });
    component.fetchJobAdsAndCompany(candidate_id);
  }
  fetchJobAdsAndCompany = candidate_id => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/jobad/get-all-with-company', {
      candidate_id: candidate_id,
      jobad_id: state.jobad_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        jobad: response.jobads[0]
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  sendPostulationNotif = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/jobad/postulation-notif', {
      jobad_id: state.jobad_id,
      candidate_id: state.candidate_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const jobad = state.jobad;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const role = app.state.session.user.roles[0];
    const status = (0, _getFormStatus.default)(state);
    let company_logo = jobad?._company?.logo?.[0]?.url;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--center"
    }, jobad?.title, " - ", jobad?._company?.company_name, company_logo ? /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: company_logo,
      className: "c-candidate-list-details__company-logo"
    }) : ""), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__first-info"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Type de contrat : ", jobad?.contract_type), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Salaire : ", jobad?.salary), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Domaine professionnel : ", jobad?._professional_domain?.label), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, jobad?.duration_type)), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__company-info"
    }, /*#__PURE__*/_react.default.createElement("h2", null, "Pr\xE9sentation de l'entreprise :"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: jobad?._company?.description
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-flex-wrap u-items-center u-margin-top-10 u-margin-bottom-10"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: jobad?._company?.website_url,
      target: "_blank",
      className: "c-candidate-list-details__website"
    }, jobad?._company?.website_url), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-candidate-list-details__location u-margin-left-15"
    }, jobad?.address?.postal_code))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-block-infos"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-block-infos__top c-block-infos__top--candidat"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 0 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 0
      })
    }, "Comp\xE9tence(s) souhait\xE9e(s)"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 1 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 1
      })
    }, "Exp\xE9rience(s) souhait\xE9e(s)"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 2 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 2
      })
    }, "Description du poste")), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 0 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: jobad?.required_skill
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 1 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: jobad?.required_experience
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 2 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: jobad?.job_description
      }
    }))), role === "candidate" ? /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      onClick: component.sendPostulationNotif,
      className: "c-btn c-btn--blue"
    }, "Je souhaite postuler \xE0 cette offre", loader) : undefined, status);
    return output;
  }
}
exports.default = JobAdsFrontListDetails;
